import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {RoutePrefix} from '../shared/route-prefix';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {Report} from './report.model';
import {ReportService} from './report.service';

@Component({
  selector: 'app-report-datatable',
  templateUrl: './report-datatable.component.html'
})
export class ReportDatatableComponent extends DatatableViewComponent<Report> implements OnInit, OnDestroy {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public linkView: boolean = false;
  @Input() public displayActions: boolean = true;

  constructor(
    private router: UIRouter,
    private reportService: ReportService
  ) {
    super(reportService);
  }

  public ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.reportService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.requestParams.addSortParam({key: (this.linkView ? 'report.name' : 'name'), value: 'asc'});
    this.fetchData();
  }

  public ngOnDestroy(): void {
    this.reportService.clearRoutePrefix();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.reportService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('management.report.edit', { reportId: event.row.id }, { reload: true });
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report-datatable.component.ts